import { useState } from 'react';
import { Row, WhiteBlock } from '../../../../../components/Basic/Blocks';
import { DropDown } from '../../../../../components/Basic/Elements';
import { Text, TextGrey } from '../../../../../components/Basic/WrapsStyle';
import { numberWithSpaces } from '../../../../../utils';
import styles from './styles.module.scss';

const ProfitBlock = ({ market, profit = {}, }) => {
  const [hover, setHover] = useState(false);

  return (
    <div className={styles.commission}>
      <div
        style={{
          color: ((profit?.total_by_report || 0) - (profit.return_blocked || 0)) >= 0 ? '#005904bd' : '#6e0000bd',
          fontSize: '20px',
          fontWeight: 600,
          ...(profit?.total_by_report === profit?.total && profit?.total == 0 && { opacity: '50%' }),
        }}
        onMouseOver={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      // className={styles.red}
      >
        {`${numberWithSpaces(Math.ceil(profit?.total_by_report - profit.return_blocked))}`}
        {profit?.total_by_report !== profit?.total && (
          <span style={{ color: profit?.total >= 0 ? '#005904bd' : '#6e0000bd', opacity: '0.7' }}> / {numberWithSpaces(Math.ceil(profit?.total))}</span>
        )}
      </div>

      {hover && (
        <DropDown styles={styles.all_commission} close={() => setHover(false)}>
          <>
            <WhiteBlock styles={styles.init}>
              <Row style={{}}>
                <TextGrey className={styles.grey_text} >Продано / потенц.:</TextGrey>
                <Text className={styles.text} style={{ color: '#006e05ff' }}>{profit?.sold_by_report} ₽{profit?.sold_by_report !== profit?.sold ? `/ ${profit?.sold} ₽` : ''}</Text>
              </Row>
              <Row style={{}}>
                <TextGrey className={styles.grey_text}>Отменено / потенц.:</TextGrey>
                <Text className={styles.text} style={{ color: profit?.cancel < 0 && '#6e0000e0' }}>{profit?.cancel_by_report} ₽{profit?.cancel_by_report !== profit?.cancel ? `/ ${profit?.cancel} ₽` : ''}</Text>
              </Row>
              <Row style={{}}>
                <TextGrey className={styles.grey_text}>Возвраты пвз / потенц.:</TextGrey>
                <Text className={styles.text} style={{ color: profit?.return_pvz < 0 && '#500000e0' }}>{profit?.return_pvz} ₽</Text>
              </Row>
              {(profit?.return_blocked || undefined) && <Row style={{}}>
                <TextGrey className={styles.grey_text}>Возвраты заблок.:</TextGrey>
                <Text className={styles.text} style={{ color: profit?.return_blocked > 0 && '#500000e0' }}>-{Math.ceil(profit?.return_blocked)} ₽</Text>
              </Row>}
              <Row style={{}}>
                <TextGrey className={styles.grey_text}>Итого / потенц.:</TextGrey>
                <Text className={styles.text} >{profit?.total_by_report} ₽{profit?.total_by_report !== profit?.total ? `/ ${profit?.total} ₽` : ''}</Text>
              </Row>

              {(profit?.potential_sale?.count || undefined ) && <Row style={{}}>
                <TextGrey className={styles.grey_text}>Доступный заработок:</TextGrey>
                <Text className={styles.text} style={{ color: '#3e4400e3' }} >{profit?.potential_sale.count} шт. / {profit?.potential_sale.profit * profit?.potential_sale.count} ₽</Text>
              </Row>}


            </WhiteBlock>
          </>
        </DropDown>
      )}
    </div>
  );
};

export default ProfitBlock;
